/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_NavInputs */

const en_svc_integration_nav = /** @type {(inputs: Svc_Integration_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI integration`)
};

const lv_svc_integration_nav = /** @type {(inputs: Svc_Integration_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI integrācija`)
};

/**
* | output |
* | --- |
* | "AI integration" |
*
* @param {Svc_Integration_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_nav = /** @type {((inputs?: Svc_Integration_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_nav(inputs)
	return en_svc_integration_nav(inputs)
});